
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dokumen/kategori/[id]",
      function () {
        return require("private-next-pages/dokumen/kategori/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dokumen/kategori/[id]"])
      });
    }
  